(() => {
  if (window.ECUOEMReferenceSearch) return;

  const key = (value) => {
    const raw = String(value ?? '').trim();
    if (!raw || raw.length > 48 || !/^[A-Z0-9 \u00a0\u2010\u2011-]+$/i.test(raw)) return '';
    const compact = raw.toUpperCase().replace(/[ \u00a0\u2010\u2011-]/g, '');
    const numeric = /^(?:\d{7}|\d{11}|0\d{9})$/.test(compact);
    const vag = /^\d[A-Z0-9]{2}\d{6}[A-Z0-9]{0,3}$/.test(compact) && /[A-Z]/.test(compact.slice(0, 3));
    const bosch = /^0\d{3}[A-Z]\d{5}$/.test(compact);
    const mercedes = /^A\d{10}$/.test(compact);
    const landRover = /^LR\d{6}$/.test(compact);
    const mec = /^MEC\d{6}$/.test(compact);
    const vdo = /^5WK\d[A-Z0-9]{4,8}$/.test(compact);
    return numeric || vag || bosch || mercedes || landRover || mec || vdo ? compact : '';
  };

  const queryKey = (value) => {
    const raw = String(value ?? '').trim();
    const result = key(raw);
    if (!result || !/^\d+$/.test(result)) return result;
    const groups = raw.replace(/[\u00a0\u2010\u2011-]/g, ' ').split(/ +/).filter(Boolean);
    if (groups.length === 1) return result;
    const sizes = groups.map((group) => group.length).join('-');
    const supportedGrouping = result.length === 7 ? sizes === '1-3-3'
      : result.length === 11 ? sizes === '2-2-1-3-3'
      : result.startsWith('0') && (sizes === '1-3-3-3' || sizes === '4-3-3');
    return supportedGrouping ? result : '';
  };

  const canonicalQuery = (value) => {
    const result = queryKey(value);
    if (/^MEC\d{6}$/.test(result)) return `${result.slice(0, 6)}-${result.slice(6)}`;
    return result || String(value ?? '').trim();
  };

  window.ECUOEMReferenceSearch = Object.freeze({ key, queryKey, canonicalQuery });

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.getAttribute('ref') !== 'searchInput') return;
    const component = input.closest('predictive-search-component');
    if (!component) return;
    const current = queryKey(input.value);
    component.querySelectorAll('[data-eo-reference-key]').forEach((label) => {
      label.hidden = !current || label.getAttribute('data-eo-reference-key') !== current;
    });
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (!(input instanceof HTMLInputElement)) return;
    let action;
    try { action = new URL(form.action, location.href); } catch { return; }
    if (action.origin !== location.origin || !action.pathname.endsWith('/search')) return;
    if (!input.value.trim()) {
      event.preventDefault();
      input.focus();
      return;
    }
    input.value = canonicalQuery(input.value);
  }, true);

  if (document.querySelector('[data-ecuoem-search-page]')) {
    const url = new URL(location.href);
    const raw = url.searchParams.get('q') ?? '';
    const normalized = queryKey(raw);
    if (normalized) {
      const canonical = canonicalQuery(raw);
      if (canonical !== raw || url.searchParams.get('type') !== 'product') {
        url.searchParams.set('q', canonical);
        url.searchParams.set('type', 'product');
        if (canonical !== raw) url.searchParams.delete('page');
        location.replace(url.toString());
      }
    }
  }
})();
